import Router from 'vue-router';
import Vue from 'vue';
// import App from './App.vue'
import { getDataWithToken } from '@/api/category';
Vue.use(Router)
const vueRouter = new Router({
  base: process.env.VUE_APP_PATH,
  mode: process.env.VUE_APP_MODE,
  routes: [{
    path: '/',
    component: () => import( /* webpackChunkName: "page" */ '@/page/index'),
    children: [{
      path: '',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list'),
    },
    {
      path: 'category',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/category'),
    }, {
      path: 'db',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/db'),
    }, {
      path: 'map',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/map'),
    }, {
      path: 'document',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/document'),
    }, {
      path: 'glob',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/glob'),
    }, {
      path: 'components',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/components'),

    }, {
      path: 'record',
      component: () => import( /* webpackChunkName: "page" */ '@/page/list/record'),
    }]
  }, {
    path: '/create',
    name: 'create',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/create')
  }, {
    path: '/build',
    name: 'build',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/build')
  }, {
    path: '/build/:id',
    name: 'build',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/build')
  }, {
    path: '/view/:id',
    name: 'view',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/view')
  }]
})


vueRouter.beforeEach(async (to, from, next) => {
  // 检查 URL 中是否有 token 参数
  const tokenPattern = /[?&]token=([^&]+)/
  const tenantId = /[?&]tenantId=([^&]+)/
  const tokenMatch = to.fullPath.match(tokenPattern)
  const tenantIdMatch = to.fullPath.match(tenantId)
  const tokenDate = localStorage.getItem('token');
  if (tokenMatch && tokenMatch[1] && tenantIdMatch && tenantIdMatch[1]) {
    const token = tokenMatch[1]
    localStorage.setItem('TENANT_ID', tenantIdMatch[1])
    localStorage.setItem('token', token)
    const cleanPath = to.fullPath.split(tokenPattern)[0]
    const newPath = cleanPath.split(tenantId)[0]
    next({
      path: newPath,
      query: {}
    })
    window.location.replace(cleanPath)
    next()
  } else if (tokenDate) {
    try {
      const res = await getDataWithToken(tokenDate)
      if (res.data === 200) {
        next();
      } else {
        next({ path: '/error', query: { message: 'invalid-token' } });
      }
    } catch (error) {
      next({ path: '/error', query: { message: 'server-error', error: error.message } });
    }
  } else {
    return;
  }
})
export default vueRouter;
